import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=3477798c&scoped=true&"
import script from "./appointment.vue?vue&type=script&lang=js&"
export * from "./appointment.vue?vue&type=script&lang=js&"
import style0 from "./appointment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./appointment.vue?vue&type=style&index=1&id=3477798c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477798c",
  null
  
)

export default component.exports